import { HelpOutlineIcon } from 'tuui';
import { TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useMotionParams } from '../hooks/useMotionParams';
import { MotionParamTagList } from './MotionParamTagList';
import { UploadedImage } from './UploadedImage';
import styles from './motionParamsPromptInput.module.scss';

export const MotionParamsPromptInput = ({ imageDataUrl, onCleanMedia }) => {
    const { value: promptOptionValue, onChange: promptOptionOnChange } = useFormFieldValue({
        field: `motionParams.textPrompt`,
    });
    const { motionParams } = useMotionParams();
    const hasTags = Object.entries(motionParams).some(([key, value]) => key !== 'prompt' && value != null);

    const { formatMessage } = useIntl();

    const promptPlaceholder = formatMessage({
        id: 'creative.editor.tab.aiGenerated.imageToMotion.prompt.placeholder',
        defaultMessage:
            'e.g. Slow cinematic zoom-in on the product box until the product fills most of the frame. Add soft lighting highlighting the edges of the box.',
    });

    const promptWithTagsPlaceholder = formatMessage({
        id: 'creative.editor.tab.aiGenerated.imageToMotion.prompt.withTags.placeholder',
        defaultMessage: 'Type your motion prompt...',
    });

    return (
        <>
            <div className={styles['prompt-label']}>
                <FormattedMessage
                    id="creative.editor.tab.aiGenerated.imageToMotion.prompt.label"
                    defaultMessage="Add a prompt to guide the motion (optional)"
                />
                <div className={styles['help-tooltip']}>
                    <Tooltip position={TOOLTIP_POSITION.TOP} arrow>
                        <FormattedMessage
                            id="creative.editor.tab.aiGenerated.imageToMotion.prompt.tooltip"
                            defaultMessage="We recommend beginning with a simple, descriptive prompt and iterating by adding more details as needed. Focus on the desired motion and camera movements, using specific and positive language."
                        />
                    </Tooltip>
                    <HelpOutlineIcon className={styles['help-icon']} />
                </div>
            </div>
            <div className={styles['prompt-input-container']}>
                <UploadedImage imageDataUrl={imageDataUrl} onCleanMedia={onCleanMedia} />
                <OutlineEditableText
                    id="motion-prompt-input"
                    data-testid="motion-prompt-input"
                    value={promptOptionValue}
                    onChange={promptOptionOnChange}
                    placeholder={hasTags ? promptWithTagsPlaceholder : promptPlaceholder}
                    className={styles['prompt-input']}
                    children={<MotionParamTagList />}
                />
            </div>
        </>
    );
};
